import { ProjectDocument, ProjectDocumentSchema } from './ProjectDocument';
import { validateEnv } from './validateEnv';
import { z, ZodError } from 'zod';

const githubRepositoryNameRegex = /^[a-zA-Z0-9-_. ]+$/;

export const validateProject = (data: ProjectDocument, options: { [key: string]: any } = {}): ZodError<ProjectDocument> => {
  // Do zod validation
  let ret = ProjectDocumentSchema.strict().safeParse(data);

  const error = ret.success ? new z.ZodError<ProjectDocument>([]) : ret.error;
  const errorByPath = (path: string) => (error.flatten().fieldErrors as any)[path] || null;
  const errorByLike = (like: string) => Object.keys(error.flatten().fieldErrors).some((key) => key.includes(like)) || null;

  // TODO: Fix validateEnv
  console.log('TODO: Fix validateEnv');
  //validateEnv(error, ['configuration.environmentVariables'], data.configuration?.environmentVariables || []);

  /*
  for (let i = 0; i < data.configuration?.repositories?.length || 0; i++) {
    const repository = data.configuration.repositories[i];
    if (!repository.url) {
      const path = [`configuration.repositories.${i}.name`];
      const name = repository.name.trim();

      if (!repository.owner) {
        error.addIssue({
          code: z.ZodIssueCode.custom,
          path: [`configuration.repositories.${i}.organization`],
          message: 'Please pick an organization',
        });
      }

      if (!name) {
        error.addIssue({
          code: z.ZodIssueCode.custom,
          path: [`configuration.repositories.${i}.repository`],
          message: 'Please pick a repository',
        });
      }

      if (!name) {
        error.addIssue({ code: z.ZodIssueCode.custom, path, message: 'Please enter a name' });
      }
      if (!githubRepositoryNameRegex.test(name)) {
        error.addIssue({ code: z.ZodIssueCode.custom, path, message: 'Invalid characters in name' });
      }
      if (name.startsWith('-') || name.startsWith('_') || name.startsWith('.')) {
        error.addIssue({ code: z.ZodIssueCode.custom, path, message: 'Must start with alphanumeric' });
      }
      if (name.endsWith('-') || name.endsWith('_') || name.endsWith('.')) {
        error.addIssue({ code: z.ZodIssueCode.custom, path, message: 'Must end with alphanumeric' });
      }
      if (name.length > 100) {
        error.addIssue({ code: z.ZodIssueCode.custom, path, message: 'Name too long' });
      }
    }
  }
    */

  // Create human readable summary of validation situation
  let summary: string | null = '';
  if (errorByPath('name')) summary = 'Please check project name';
  if (errorByPath('tweakedDomainSlug')) summary = 'Please check project domain';
  if (errorByLike('configuration.environmentVariables')) summary = 'Please check environment variables';
  if (errorByLike('configuration.repositories.')) summary = 'Please check repository options';
  if (error.issues.length && !summary) summary = 'Unexpected error';
  if (error.issues.length) {
    error.addIssue({ code: z.ZodIssueCode.custom, path: ['summary'], message: summary });
  }

  return error;
};
